export default "__VITE_ASSET__rUqhouiB__"